import { FC, useState } from 'react';
import { FileUploaderComp, ModalComp, TextInputComp } from '..';
import { SelectComp } from '..';
import { Controller, useForm } from 'react-hook-form';
import { Radio } from 'antd';
import styled from 'styled-components';
import { useCreateCreditScoreMutation } from '../../../store/creditScoreApi';
import { showErrorToast, showSuccessToast } from '../../utils';
import { useParams, useNavigate } from 'react-router-dom';
import { getAdminId } from '../../utils';

interface ILoanModal {
    showLoanModal: boolean;
    loanItem: string;
    cancelLoan: () => void;
    handleStatus: any;
}

export const LoanApprovalModal: FC<ILoanModal> = ({
    showLoanModal,
    loanItem,
    cancelLoan,
    handleStatus,
}) => {
    const param = useParams();
    const requestId = param?.id as string;
    const adminId = getAdminId();
    const [loanHistory, setLoanHistory] = useState<string>('auto');
    const [status, setStatus] = useState<string>('approve');
    const [createCreditScore, { isLoading }] = useCreateCreditScoreMutation();

    const { handleSubmit, control, reset } = useForm({
        defaultValues: {
            newData: {
                issuerRequest: '',
                creditScore: '',
                internalAnalystComment: '',
                annualCashFlowEstimate: '',
                debtToIncome: '',
                riskCategory: '',
                loanHistory: '',
                creditBureauScore: '',
                internalReviewUrl: '',
                monitoringFrequency: '',
                collateralDetails: '',
                verificationStatus: '',
                authorizedBy: '',
            },
        },
    });

    const onHandleSubmit = (value: {
        newData: {
            issuerRequest: string;
            creditScore: string;
            internalAnalystComment: string;
            annualCashFlowEstimate: string | number;
            debtToIncome: string | number;
            riskCategory: string;
            loanHistory: string;
            creditBureauScore: string | number;
            internalReviewUrl: string;
            monitoringFrequency: string;
            collateralDetails: string;
            verificationStatus: string;
            authorizedBy: any;
        };
    }) => {
        const payload = {
            issuerRequest: requestId,
            creditScore: value?.newData.creditScore,
            internalAnalystComment: value?.newData?.internalAnalystComment,
            annualCashFlowEstimate: Number(
                value?.newData?.annualCashFlowEstimate,
            ),
            debtToIncome: Number(value?.newData?.debtToIncome),
            riskCategory: value?.newData?.riskCategory,
            loanHistory: loanHistory,
            creditBureauScore: Number(value.newData?.creditBureauScore),
            internalReviewUrl: value.newData?.internalReviewUrl,
            monitoringFrequency: value?.newData?.monitoringFrequency,
            collateralDetails: value?.newData?.collateralDetails,
            verificationStatus: status,
            authorizedBy: adminId,
        };

        createCreditScore(payload)
            .unwrap()
            .then((result) => {
                showSuccessToast(result?.message);
                handleStatus('approved');
                reset();
            })
            .catch((error) => {
                console.error('Error submitting request:', error);
                showErrorToast(error?.data?.message[0]);
            });
    };
    return (
        <ModalComp
            show={showLoanModal}
            handleClose={cancelLoan}
            centered
            close={true}
            size="lg"
            modalTitle={'Appoval Confirmation'}
            paragraph={
                'Fill in the appropriate information to complete the approval.'
            }
            modalBody={
                <div className="py-2 ">
                    <FlexWrap onSubmit={handleSubmit(onHandleSubmit)}>
                        <Controller
                            name="newData.creditScore"
                            control={control}
                            rules={{
                                required: 'Credit score is required',
                            }}
                            render={({
                                field: { value, onChange },
                                formState: { errors },
                            }) => {
                                const errorMessage =
                                    errors?.newData?.creditScore?.message;
                                return (
                                    <SelectComp
                                        labelText="Ibx Credit Score"
                                        arrayComp={['AAA', 'BBB', 'CCC']}
                                        name="creditScore"
                                        defaultValue={'site'}
                                        {...{
                                            value,
                                            onChange,
                                            errors: [errorMessage],
                                        }}
                                    />
                                );
                            }}
                        />
                        <Controller
                            name="newData.internalAnalystComment"
                            control={control}
                            rules={{
                                required:
                                    'Internal analyst comment is required',
                            }}
                            render={({
                                field: { value, onChange },
                                formState: { errors },
                            }) => {
                                const errorMessage =
                                    errors?.newData?.internalAnalystComment
                                        ?.message;
                                return (
                                    <TextInputComp
                                        labelText="Internal Analyst Comment"
                                        placeholder="Tell us more"
                                        name="internalAnalystComment"
                                        {...{
                                            value,
                                            onChange,
                                            errors: [errorMessage],
                                        }}
                                    />
                                );
                            }}
                        />
                        <Flex>
                            <Controller
                                name="newData.annualCashFlowEstimate"
                                control={control}
                                rules={{
                                    required: 'Annual cash flow is required',
                                }}
                                render={({
                                    field: { value, onChange },
                                    formState: { errors },
                                }) => {
                                    const errorMessage =
                                        errors?.newData?.annualCashFlowEstimate
                                            ?.message;
                                    return (
                                        <TextInputComp
                                            labelText="Annual Cash Flow Estimate"
                                            placeholder="0"
                                            inputType="number"
                                            name="email"
                                            {...{
                                                value,
                                                onChange,
                                                errors: [errorMessage],
                                            }}
                                        />
                                    );
                                }}
                            />

                            <Controller
                                name="newData.debtToIncome"
                                control={control}
                                rules={{
                                    required: 'Debt-To-Income is required',
                                }}
                                render={({
                                    field: { value, onChange },
                                    formState: { errors },
                                }) => {
                                    const errorMessage =
                                        errors?.newData?.debtToIncome?.message;
                                    return (
                                        <TextInputComp
                                            labelText="Key Ratios(Debt-to-income)"
                                            placeholder="0"
                                            inputType="number"
                                            name="debtToIncome"
                                            {...{
                                                value,
                                                onChange,
                                                errors: [errorMessage],
                                            }}
                                        />
                                    );
                                }}
                            />
                        </Flex>
                        <FlexDiv>
                            <Select>
                                <Controller
                                    name="newData.riskCategory"
                                    control={control}
                                    rules={{
                                        required: 'Risk Category is required',
                                    }}
                                    render={({
                                        field: { value, onChange },
                                        formState: { errors },
                                    }) => {
                                        const errorMessage =
                                            errors?.newData?.riskCategory
                                                ?.message;
                                        return (
                                            <SelectComp
                                                labelText="Risk Category"
                                                styleClass="Select"
                                                arrayComp={[
                                                    'High Risk',
                                                    'Low Risk',
                                                ]}
                                                name="riskCategory"
                                                defaultValue={'site'}
                                                {...{
                                                    value,
                                                    onChange,
                                                    errors: [errorMessage],
                                                }}
                                            />
                                        );
                                    }}
                                />
                            </Select>
                            <RadioWrap>
                                <label
                                    htmlFor="imageUpload"
                                    style={{ textAlign: 'start' }}
                                >
                                    Loan History on IBX
                                </label>
                                <RadioFlex>
                                    <Radio.Group
                                        name="newData.loanHistory"
                                        defaultValue={'auto'}
                                        options={[
                                            { value: 'auto', label: 'Auto' },
                                            {
                                                value: 'manual',
                                                label: 'Manual',
                                            },
                                        ]}
                                        onChange={(e) =>
                                            setLoanHistory(e.target.value)
                                        }
                                    />
                                </RadioFlex>
                            </RadioWrap>
                        </FlexDiv>
                        <Controller
                            name="newData.creditBureauScore"
                            control={control}
                            rules={{
                                required: 'Credit Bureau Score is required',
                            }}
                            render={({
                                field: { value, onChange },
                                formState: { errors },
                            }) => {
                                const errorMessage =
                                    errors?.newData?.creditBureauScore?.message;
                                return (
                                    <TextInputComp
                                        labelText="Credit Bureau Score"
                                        placeholder="0"
                                        inputType="number"
                                        name="creditBureauScore"
                                        {...{
                                            value,
                                            onChange,
                                            errors: [errorMessage],
                                        }}
                                    />
                                );
                            }}
                        />
                        <label
                            htmlFor="imageUpload"
                            style={{ textAlign: 'start' }}
                        >
                            Internal Revenue
                        </label>
                        <File>
                            <Controller
                                name="newData.internalReviewUrl"
                                control={control}
                                render={({
                                    field: { value, onChange },
                                    formState: { errors },
                                }) => {
                                    return (
                                        <Filewrap>
                                            <FileUploaderComp
                                                defaultValue={
                                                    'internalReviewUrl'
                                                }
                                                {...{ value, onChange }}
                                            />
                                            <Text>Upload file here</Text>
                                        </Filewrap>
                                    );
                                }}
                            />
                        </File>
                        <label
                            htmlFor="imageUpload"
                            style={{
                                textAlign: 'center',
                                fontSize: '14px',
                                fontWeight: '300',
                            }}
                        >
                            Ensure file is not more than 5mb
                        </label>
                        <Flex>
                            <Controller
                                name="newData.monitoringFrequency"
                                control={control}
                                rules={{
                                    required:
                                        'Monitoring Frequency is required',
                                }}
                                render={({
                                    field: { value, onChange },
                                    formState: { errors },
                                }) => {
                                    const errorMessage =
                                        errors?.newData?.monitoringFrequency
                                            ?.message;
                                    return (
                                        <SelectComp
                                            labelText="Monitoring Frenquency"
                                            arrayComp={[
                                                'Monthly',
                                                'Quarterly',
                                                'Yearly',
                                            ]}
                                            name="location"
                                            defaultValue={'site'}
                                            {...{
                                                value,
                                                onChange,
                                                errors: [errorMessage],
                                            }}
                                        />
                                    );
                                }}
                            />

                            <Controller
                                name="newData.collateralDetails"
                                control={control}
                                rules={{
                                    required: 'Email is required',
                                }}
                                render={({
                                    field: { value, onChange },
                                    formState: { errors },
                                }) => {
                                    const errorMessage =
                                        errors?.newData?.collateralDetails
                                            ?.message;
                                    return (
                                        <TextInputComp
                                            labelText="Collateral Details"
                                            placeholder="Tell us more"
                                            name="email"
                                            {...{
                                                value,
                                                onChange,
                                                errors: [errorMessage],
                                            }}
                                        />
                                    );
                                }}
                            />
                        </Flex>
                        <Flex>
                            <RadioWrap>
                                <label
                                    htmlFor="imageUpload"
                                    style={{ textAlign: 'start' }}
                                >
                                    Select Verification Status
                                </label>
                                <RadioFlex>
                                    <div></div>
                                    <Radio.Group
                                        name="newData.verificationStatus"
                                        defaultValue={'approve'}
                                        options={[
                                            {
                                                value: 'approve',
                                                label: 'Approve',
                                            },
                                            {
                                                value: 'reject',
                                                label: 'Reject',
                                            },
                                            {
                                                value: 'pending',
                                                label: 'Pending',
                                            },
                                        ]}
                                        onChange={(e) =>
                                            setStatus(e.target.value)
                                        }
                                    />
                                </RadioFlex>
                            </RadioWrap>
                        </Flex>
                        <Button type="submit">
                            {isLoading ? 'Loading...' : 'Submit'}
                        </Button>
                    </FlexWrap>
                </div>
            }
        />
    );
};

const FlexWrap = styled.form`
    display: flex;
    flex-direction: column;
    gap: 25px;
    margin-block: 10px;
`;

const FlexDiv = styled.form`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    gap: 10px;

    @media screen and (max-width: 400px) {
        flex-direction: column;
        justify-content; start;
        align-items: start;
    }
`;

const Flex = styled.div`
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: start;
    gap: 10px;

    @media screen and (max-width: 400px) {
        flex-direction: column;
    }
`;

const File = styled.div`
    background: #e2e8f0;
    display: flex;
    justify-content: center;
    border-radius: 8px;
`;

const Filewrap = styled.div`
    display: flex;
    justify-content: center;
    align-itmes: center;
    flex-direction: column;
    font-size: 14px;
    gap: 10px;
    margin-left: 15px;
`;

const Text = styled.div`
    margin-left: 13px;
`;

const RadioWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;
const RadioFlex = styled.div`
    border-radius: 8px;
    padding: 8px 10px;
    background: #e2e8f0;
`;
const Select = styled.div`
    width: 50%;
    @media screen and (max-width: 400px) {
        width: 100%;
    }
`;

const Button = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    background: #7041de;
    color: #fff;
    width: 80px;
    border: none;
    font-size: 16px;
    padding: 10px 50px;
    border-radius: 4px;
    text-align: center;
    width: 100%;
    margin-top: 10px;

    &:disabled {
        background: #ccc;
        cursor: not-allowed;
    }
`;
